import Icon from "components/Icon"

import { Counter } from "./styled"
import type { CounterPlacement, CounterVariant } from "./types"

export interface CarouselCounterProps {
  readonly activeIndex: number
  readonly childrenCount: number
  readonly counterPlacement?: CounterPlacement
  readonly counterVariant?: CounterVariant
  readonly isShowCounter: boolean
  readonly isShowCounterTop?: boolean
  readonly isShowThumbnails: boolean
}

const CarouselCounter = ({
  activeIndex,
  childrenCount,
  counterPlacement,
  counterVariant = "total",
  isShowCounter,
  isShowCounterTop,
  isShowThumbnails
}: CarouselCounterProps) => {
  if (!isShowCounter) return null

  const resolvedPlacement: CounterPlacement =
    counterPlacement ?? (isShowCounterTop ? "top-right" : "bottom-right")

  const normalizedIndex = Math.min(
    Math.max(activeIndex + 1, 1),
    Math.max(childrenCount, 1)
  )
  const label =
    counterVariant === "progress"
      ? `${normalizedIndex} / ${childrenCount}`
      : `${childrenCount}`
  const ariaLabel =
    counterVariant === "progress"
      ? `Slide ${normalizedIndex} of ${childrenCount}`
      : `${childrenCount} items`

  return (
    <Counter
      $isShowThumbnails={isShowThumbnails}
      $placement={resolvedPlacement}
      $variant={counterVariant}
      aria-label={ariaLabel}
    >
      <Icon group="fa6" name="FaCameraRetro" />

      <span>{label}</span>
    </Counter>
  )
}

export default CarouselCounter
